var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-ohe.6088638a.png","uri@2x": __webpack_public_path__ + "icon-ohe.a0df1e1d.png","uri@3x": __webpack_public_path__ + "icon-ohe.646764d6.png",
    width: 20,
    height: 20
});